<template>
  <footer class="footer">
    <div v-accordion="{ closeOthers: false, mediaQuery: mq('to-small') }" class="footer__container">
      <div class="footer-item footer-item--company">
        <h6
          id="footer-trigger-address"
          class="footer-item__header js-accordion-toggler"
          aria-controls="footer-content-address"
          :aria-expanded="isTriggerExpanded">
          {{ context.companyInformation.headline }}
        </h6>

        <address
          id="footer-content-address"
          class="footer-item__content footer-item__content--address"
          aria-labelledby="footer-trigger-address"
          :aria-hidden="isContentHidden">
          <ul class="footer-item__list">
            <li v-for="item of context.companyInformation.addressItems" :key="item.name" class="footer-item__list-item">
              <a v-if="item.url" :href="item.url" class="footer-item__link">{{ item.name }}</a>
              <template v-else>
                {{ item.name }}
              </template>
            </li>
          </ul>

          <ul class="footer-item__list footer-item__list--contact">
            <li v-for="item of context.companyInformation.contactItems" :key="item.name" class="footer-item__list-item">
              <a v-if="item.url" :href="item.url" class="footer-item__link">{{ item.name }}</a>
              <template v-else>
                {{ item.name }}
              </template>
            </li>
          </ul>

          <div v-if="mq('to-small')" class="footer-item__contact-actions">
            <oie-base-button
              is-type="a"
              url="0304-751010"
              text="0304-751010"
              css-classes="button-link"></oie-base-button>

            <oie-base-button
              is-type="a"
              url="order@oie.se"
              text="order@oie.se"
              css-classes="button-link"></oie-base-button>
          </div>
        </address>
      </div>

      <div v-for="item of context.links" :key="item.headline" class="footer-item">
        <h6
          :id="`footer-trigger-${item.headline}`"
          class="footer-item__header js-accordion-toggler"
          :aria-controls="`footer-content-${item.headline}`"
          :aria-expanded="isTriggerExpanded">
          {{ item.headline }}
        </h6>

        <div
          :id="`footer-content-${item.headline}`"
          class="footer-item__content"
          :aria-labelledby="`footer-trigger-${item.headline}`"
          :aria-hidden="isContentHidden">
          <ul class="footer-item__list">
            <li v-for="linkItem of item.items" :key="linkItem.headline" class="footer-item__list-item">
              <a v-if="linkItem.url" :href="linkItem.url" class="footer-item__link">{{ linkItem.name }}</a>
              <template v-else>
                {{ linkItem.name }}
              </template>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer-item footer-item--social">
        <h6 class="footer-item__social-header">
          {{ context.social.headline }}
        </h6>
        <div class="footer-item__social-content">
          <a
            v-for="link of context.social.items"
            :key="link.name"
            :href="link.url"
            target="_blank"
            rel="noopener noreferrer"
            class="footer-item__social-link">
            <oie-use-svg :svg="link.name"></oie-use-svg>
          </a>
        </div>
      </div>

      <div class="footer-item__bottom">
        <div class="footer-item__faq-news">
          <!-- <div class="footer-item__faq">
            <h6 class="footer-item__faq-news-header">
              Kundservice
            </h6>

            <a href="#0" class="interaction-item interaction-item--link-button interaction-item--reversed-icon">
              <svg
                slot="icon"
                class="interaction-item__icon"
                width="16"
                height="23"
                viewBox="0 0 16 23"
                xmlns="http://www.w3.org/2000/svg"><path d="M10.66 11.894L.88 3 2.9.78l12.22 11.114L2.908 23 .89 20.78z" fill="#44B1FA" fill-rule="nonzero" /></svg> Vanliga frågor och svar
            </a>
          </div> -->

          <oie-footer-newsletter></oie-footer-newsletter>
        </div>

        <div class="footer-item--logos">
          <a href="#0" class="footer-item__cert-links" rel="noopener noreferrer">
            <oie-base-image
              id="TEH_LOGOTYPE"
              :images="getAssetPath('@/assets/images/trygg-e-handel.svg')"
              alt-text="Trygg ehandel"
              image-width="4.75rem"
              image-height="4.75rem"
              class="footer-item__logo"
              data-top="180"></oie-base-image>
          </a>

          <a href="#0" class="footer-item__cert-links" rel="noopener noreferrer">
            <oie-base-image
              images="https://ratinglogo.bisnode.com/2462895103803053693074041.svg"
              alt-text="Högsta kreditvärdihet sedan 2017"
              image-width="283px"
              image-height="87"
              class="footer-item__logo"></oie-base-image>
          </a>
        </div>
      </div>
      <div class="footer__copyright">
        <a class="footer-item__link" href="https://www.olssonparts.com/se/sv/kundservice/villkor/upphovsratt/">© Olsson Parts 2022 . All Rights reserved.</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data: () => ({
    context: {
      companyInformation: {},
      links: [],
      social: {}
    }
  }),
  computed: {
    isTriggerExpanded() {
      return !this.mq('to-small')
    },
    isContentHidden() {
      return this.mq('to-small')
    }
  },
  mounted() {
    this.context.companyInformation = {
      headline: 'Olssons i Ellös',
      addressItems: [
        {
          name: 'Olssons i Ellös AB'
        },
        {
          name: 'Slätthultsvägen 12'
        },
        {
          name: '473 31 Ellös'
        }
      ],
      contactItems: [
        {
          name: 'Tel 0304-751010',
          url: 'tel:+46304751010'
        },
        {
          name: 'Fax 0304-751011'
        },
        {
          name: 'order@oie.se',
          url: 'mailto:order@oie.se'
        },
        {
          name: 'Org.nr.556617-0154'
        }
      ]
    }

    this.context.links.push({
      headline: 'Företaget',
      items: [
        {
          name: 'Om oss',
          url: '/om-oss'
        },
        {
          name: 'Personal',
          url: '/personal'
        },
        {
          name: 'Hitta hit',
          url: '/Hitta hit'
        },
        {
          name: 'Lediga tjänster',
          url: '/lediga-tjanster'
        },
        {
          name: 'Mässprogram',
          url: '/massprogram'
        }
      ]
    })

    this.context.links.push({
      headline: 'Kundservice',
      items: [
        {
          name: 'Kundtjänst',
          url: '/kundtjanst'
        },
        {
          name: 'Öppettider',
          url: '/oppettider'
        },
        {
          name: 'Frakter',
          url: '/frakter'
        },
        {
          name: 'Betalsätt',
          url: '/betalsatt'
        },
        {
          name: 'Leveranser',
          url: '/leveranser'
        },
        {
          name: 'Köpguide',
          url: '/kopguide'
        },
        {
          name: 'Integritetspolicy',
          url: '/integritetspolicy'
        },
        {
          name: 'Köpvillkor',
          url: '/kopvillkor'
        },
        {
          name: 'Returer & reklamation',
          url: '/returer-reklamation'
        }
      ]
    })

    this.context.links.push({
      headline: 'Produkter',
      items: [
        {
          name: 'Våra märken',
          url: '/vara-marken'
        },
        {
          name: 'Reservdelar',
          url: '/reservdelar'
        },
        {
          name: 'utrustning',
          url: '/utrustning'
        },
        {
          name: 'Fordonstyper',
          url: '/fordonstyper'
        }
      ]
    })

    this.context.social = {
      headline: 'Följ oss',
      items: [
        {
          name: 'instagram',
          url: 'https://linkedin.com/oie'
        },
        {
          name: 'facebook',
          url: 'https://donotusebook.com/oie'
        },
        {
          name: 'youtube',
          url: 'https://youtube.com/oie'
        }
      ]
    }
  }
}
</script>
